var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 12,
    cy: 2.5,
    r: 1.5,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 16.75,
    cy: 3.77,
    r: 1.5,
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 20.23,
    cy: 7.25,
    r: 1.5,
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 21.5,
    cy: 12,
    r: 1.5,
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 20.23,
    cy: 16.75,
    r: 1.5,
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 16.75,
    cy: 20.23,
    r: 1.5,
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 12,
    cy: 21.5,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.ff48dffb1a26edddf9339e651799a85e.svg";
export { ForwardRef as ReactComponent };